import IdManager from '../IdManager/index'

export default function (superClass) {
  return class extends superClass {
    constructor(...arg) {
      // @ts-ignore
      super(...arg)
    }

    install() {
      super.install()
    }

    destroy() {
      super.destroy()
    }

    display() {
      return super.display() + `
      <defs>
        <filter id="nodeFilterHover">
          <feGaussianBlur in="SourceAlpha" stdDeviation="2.2">
          </feGaussianBlur>
          <feOffset dx="1" dy="1" result="offsetblur"></feOffset>
          <feFlood flood-color="rgba(0,0,0,1)"></feFlood>
          <feComposite in2="offsetblur" operator="in">
          </feComposite>
          <feMerge>
            <feMergeNode>
            </feMergeNode>
            <feMergeNode in="SourceGraphic"></feMergeNode>
          </feMerge>
        </filter>
        <filter id="nodeFilter" x="0" y="0">
          <feOffset result="offOut" in="SourceAlpha" dx="1" dy="1"></feOffset>
          <feGaussianBlur result="blurOut" in="offOut" stdDeviation="1">
          </feGaussianBlur>
          <feBlend in="SourceGraphic" in2="blurOut" mode="normal">
          </feBlend>
        </filter>
        <filter x="0" y="0" width="1" height="1" id="${IdManager.join(this.id, "labelBackgroundFilter")}">
          <feFlood flood-color="#fff" flood-opacity=".8"/>
          <feComposite in="SourceGraphic" operator="over"/>
        </filter>
        <filter id="${IdManager.join(this.id, "screenBlendMode")}">
          <feFlood flood-color="#fff" flood-opacity=".3"/>
          <feComposite in="SourceGraphic"/>
        </filter>


        <marker 
          id=${this.id + 'hotArea4polyline'}
          markerWidth='20'
          markerHeight='16'
          orient='auto' 
          viewBox='-14 -8 20 16'
          markerUnits='userSpaceOnUse'
        >
          <path fill=blue fill-opacity=.3 d='M-16,-8 H4 V8 H-16 Z' />
        </marker>

      </defs>`
    }
  }
}



// WEBPACK FOOTER //
// ./src/common/components/process-editor/modules/Layers/DefsLayerMixin.js